export default __webpack_public_path__ + "static/media/valley6.785223bd.png";